module.exports = __webpack_public_path__ + "static/media/g1.d3448a92.png";